import React, { lazy, Suspense } from 'react';

import type { InvitePeopleDialogProps } from './main';

type LazyAddPeopleDialogComponent = ((props: InvitePeopleDialogProps) => React.ReactElement) & {
	displayName?: string;
};

const InvitePeopleDialogSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_invite-people-dialog" */ './main'
		),
);

const LazyAddPeopleDialog: LazyAddPeopleDialogComponent = (props) => (
	<Suspense fallback={null}>
		<InvitePeopleDialogSuspense {...props} />
	</Suspense>
);
LazyAddPeopleDialog.displayName = 'lazy(LazyAddPeopleDialog)';

export default LazyAddPeopleDialog;
